import _slicedToArray from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useId } from '@reach/auto-id';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { LayerContext } from './context';
export function LayerProvider(props) {
  var _props$baseDepth = props.baseDepth,
      baseDepth = _props$baseDepth === void 0 ? 0 : _props$baseDepth,
      children = props.children,
      idProp = props.id;
  var parentLayer = useContext(LayerContext);

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  var idsRef = useRef([]);
  var currentId = useId(idProp);
  var mount = useCallback(function (id) {
    setSize(function (val) {
      return val + 1;
    });

    if (idsRef.current.includes(id)) {
      throw new Error("Layer: id already exists (\"".concat(id, "\")"));
    }

    idsRef.current.push(id);
    return function () {
      setSize(function (val) {
        return val - 1;
      });
      var idx = idsRef.current.indexOf(id);

      if (idx > -1) {
        idsRef.current.splice(idx, 1);
      }
    };
  }, []);
  var layer = useMemo(function () {
    var layerDepth = parentLayer ? parentLayer.depth + 1 : 0;
    var layerSize = parentLayer ? parentLayer.size : size;

    var _currentId = parentLayer ? parentLayer.currentId : idsRef.current[idsRef.current.length - 1];

    return {
      currentId: _currentId,
      depth: baseDepth + layerDepth,
      isTopLayer: currentId === _currentId,
      mount: (parentLayer === null || parentLayer === void 0 ? void 0 : parentLayer.mount) || mount,
      size: layerSize
    };
  }, [baseDepth, currentId, mount, parentLayer, size]);
  var mountFn = layer.mount;
  useEffect(function () {
    if (!currentId) return undefined;
    return mountFn(currentId);
  }, [currentId, mountFn]);
  return React.createElement(LayerContext.Provider, {
    value: layer
  }, children);
}